export default "/images/recruit-manage-jobs.png?c15b25f53a723663a2e42427e3092b8d";